import { connect } from "react-redux";
import EditCounteragentScreen from "./EditCounteragentScreen";
import { editCounteragent } from "src/counteragents/redux/actions";

export default connect(
  (state) => {
    return {
      profile: state.auth.profile,
    };
  },
  {
    editCounteragent,
  }
)(EditCounteragentScreen);
